import { combineReducers } from 'redux'

import authenticate from './authenticate'
import login from './login'

export default combineReducers({
  authenticate: authenticate,
  login: login
})
